import { Box, IconButton, Typography } from '@material-ui/core'

import track from 'assets/icons/track.svg'

import { CommonDialog } from 'UI/Components'
import { TrackLinkContent } from './TrackLinkContent'

import { useBoolean, useNotification } from 'hooks'
import { PlaybookType } from 'app/types'

type Props = {
    playbook: PlaybookType
    disabled?: boolean
}

export const TrackLink = ({ playbook, disabled }: Props) => {
    const trackLink = useBoolean()

    const { showWarningNotification } = useNotification()

    const handleIconCLick = () => {
        if (disabled)
            return showWarningNotification(
                'The video privacy settings require you to share it with anyone in order to use tracking link'
            )

        trackLink.setTrue()
    }

    return (
        <>
            <Box display="flex" justifyContent="start" alignItems="center" flexDirection="column">
                <IconButton
                    title="Track link"
                    size="small"
                    onClick={handleIconCLick}
                    style={{ background: 'gainsboro', opacity: disabled ? 0.5 : 1 }}
                >
                    <img src={track} alt="track" />
                </IconButton>
                <Typography variant="body2">Track</Typography>
            </Box>

            <CommonDialog
                isOpen={trackLink.isTrue}
                onClose={trackLink.setFalse}
                content={<TrackLinkContent playbook={playbook} />}
                noPadding={true}
                noBackground={true}
            />
        </>
    )
}
